export const VIRTUAL_INVOICE_STATUS = {
    '0': "Ödeme Bekliyor",
    '1': "Banka mutabakatı bekleniyor",
    '2': "Banka mutabakatı bekleniyor",
    '3': "Banka mutabakatı bekleniyor",
    '4': "Ödeme Bekliyor",
    '5': "Banka mutabakatı bekleniyor",
    '6': "Banka mutabakatı bekleniyor",
    '7': "Süresi doldu",
    '8': "Paket Yüklendi", 
    '9': "Ödeme İptal Mutabakatı Tamamlandı(9)."
};

export const alphaStatus = {
    REJECTED: 'REDDEDİLDİ',
    INPROGRESS: 'ONAYDA',
    ACTIVE: 'ONAYLANDI',
  };